document.addEventListener("DOMContentLoaded", () => {
    const swiper = new Swiper('.swiper-styleguide', {
        speed: 400,
        spaceBetween: 100,
        navigation: {
            nextEl: '.swiper-button-next', // Next button
            prevEl: '.swiper-button-prev'  // Previous button
        },
        pagination: {
            el: '.swiper-pagination', // Dots container
            clickable: true           // Allow clicking dots to navigate
        }
    });
});

// accordion open/close
document.addEventListener('DOMContentLoaded', function () {
    const accordions = document.querySelectorAll(".Faq_accordion_item");
    const openAccordion = (accordion) => {
        const content = accordion.querySelector(".Faq_accordion_item--body");
        accordion.classList.add("active_accordion");
        content.style.maxHeight = content.scrollHeight + "px";
    };
    const closeAccordion = (accordion) => {
        const content = accordion.querySelector(".Faq_accordion_item--body");
        accordion.classList.remove("active_accordion");
        content.style.maxHeight = null;
    };

    var firstAccordionItem = document.querySelector('.Faq_accordion_item');
    if (firstAccordionItem) {
        openAccordion(firstAccordionItem);
    }
    accordions.forEach((accordion) => {
        const accTitle = accordion.querySelector(".Faq_accordion_item--title");
        const content = accordion.querySelector(".Faq_accordion_item--body");

        accTitle.onclick = () => {
            if (content.style.maxHeight) {
                closeAccordion(accordion);
            } else {
                accordions.forEach((accordion) => closeAccordion(accordion));
                openAccordion(accordion);
            }
        };
    });
});

// accordion smooth scroll
function handleScrollBehavior() {
    document.querySelectorAll('.faq__sidebar-link').forEach(link => {
        link.addEventListener('click', function (e) {
            e.preventDefault();
            var hrefAttr = this.getAttribute("href").replace('#', '');

            let anchorLink = document.getElementById(hrefAttr);
            document.querySelector('.faq__sidebar-link--active').classList.remove('faq__sidebar-link--active');
            this.classList.add('faq__sidebar-link--active');

            var windowWidth = window.innerWidth;
            var offsetTopSize = 150;

            if (windowWidth < 1025) {
                offsetTopSize = 300;
            } else {
                offsetTopSize = 150;
            }

            window.scrollTo({
                top: anchorLink.offsetTop - offsetTopSize,
                behavior: "smooth"
            });
        });
    });
}

// Run the scroll behavior when the page loads
window.addEventListener('load', handleScrollBehavior);

// Run the scroll behavior again when the window is resized
window.addEventListener('resize', handleScrollBehavior);

document.addEventListener('DOMContentLoaded', function () {
    document.querySelector('.faq__sidebar-title').addEventListener('click', function () {
        document.querySelector('.faq__sidebar').classList.toggle('collapse_sidebar');
    });

    document.querySelectorAll('.faq__sidebar-link').forEach(function (link) {
        link.addEventListener('click', function () {
            document.querySelector('.faq__sidebar').classList.remove('collapse_sidebar');
        });
    });

});